import { Component, AfterViewInit, ElementRef, HostListener } from '@angular/core';
import { Colors } from './models/enums/colors.enum';
import { ChartType } from './components/charts/chart/model/chart-type.model';
import { AnimationSpeed } from './models/enums/animation-speed.enum';
import { ComponentHeight } from './models/enums/component-height.enum';
import { ComponentWidth } from './models/enums/component-width.enum';
import { HttpService } from './services/http.service';
import { ErrorNoticeService } from './services/error-notice.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
    colors = Colors;
    animationSpeeds = AnimationSpeed;
    componentHeights = ComponentHeight;
    componentWidths = ComponentWidth;
    chartType = ChartType;
    
    error:boolean;

    constructor(private http: HttpService, private errorNotice: ErrorNoticeService) {
        http.fetchData();
        setInterval(() => {
            http.fetchData();
        }, 2000);

        this.errorNotice.Error().subscribe(error => {
            this.error = error;
        });
     }

    ngOnInit() {
    }

    ngAfterViewInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts